import { render, staticRenderFns } from "./AiListFooter.vue?vue&type=template&id=67c56d58&scoped=true&"
import script from "./AiListFooter.vue?vue&type=script&lang=js&"
export * from "./AiListFooter.vue?vue&type=script&lang=js&"
import style0 from "./AiListFooter.vue?vue&type=style&index=0&id=67c56d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c56d58",
  null
  
)

export default component.exports